
import moment from 'moment';
import { Component, Mixins } from 'vue-property-decorator';
import { Iter } from '@/types';
import PracticeNotesIcon from '@/components/PracticeNotesIcon.vue';
import OperationComponentMixin from '@/mixins/OperationComponentMixin.vue';

moment.locale('it');

@Component({
  components: {
    PracticeNotesIcon,
  },
})

export default class OperationPraticesAndVerifications extends Mixins(OperationComponentMixin) {
  get iter(): Iter | null {
    return this.operationChild?.iter || null;
  }

  get iterSelected(): boolean {
    return this.iter !== null;
  }

  get iterTitle(): string {
    if (this.iter === 'o') return 'O';
    if (this.iter === 's') return 'S';
    if (this.iter === 'bo') return 'Bo';
    if (this.iter === 'bs') return 'Bs';
    if (this.iter === 'b') return 'B';
    if (this.iter === 'ps') return 'Ps';
    if (this.iter === 'n') return 'N';
    return '';
  }

  get iterDescription(): string {
    if (this.iter === 'o') return 'Iter: Ordinario';
    if (this.iter === 's') return 'Iter: Semplificato';
    if (this.iter === 'bo') return 'Iter: Superbonus 110% - Ordinario';
    if (this.iter === 'bs') return 'Iter: Superbonus 110% - Semplificato';
    if (this.iter === 'b') return 'Iter: Superbonus 110%';
    if (this.iter === 'ps') return 'Pre Check Connessione';
    if (this.iter === 'n') return 'Iter: Non applicabile';
    return 'Iter: Non selezionato';
  }

  get hasPracticeNotes(): boolean {
    return this.operation?.hasPracticeNotes === true;
  }

  get hasP(): boolean {
    return this.operationChild?.p === 'done' || this.operationChild?.p === 'na';
  }

  get hasC(): boolean {
    return this.operationChild?.c === 'done' || this.operationChild?.c === 'na';
  }

  get hasV(): boolean {
    return this.childProjectType === 'elettrica-figlia'
      ? this.eCostsVerified
      : this.tCostsVerified
        && this.tConversionDone
        && this.tCeilingsVerified
        && this.tCertifierVerified;
  }

  get eCostsVerified(): boolean {
    return this.operationChild?.eCostsVerified === true;
  }

  get tCostsVerified(): boolean {
    return this.operationChild?.tCostsVerified === true;
  }

  get tConversionDone(): boolean {
    return this.operationChild?.tConversionDone === true;
  }

  get tCeilingsVerified(): boolean {
    return this.operationChild?.tCeilingsVerified === true;
  }

  get tCertifierVerified(): boolean {
    return this.operationChild?.tCertifierVerified === true;
  }

  get isTaskCompleted(): boolean {
    return this.operationChild?.flatTasks.includes('V=c') ?? false;
  }

  get isTaskFailed(): boolean {
    return this.operationChild?.flatTasks.includes('V=e') ?? false;
  }

  // Iter (prima colonna)

  get iterColumnClass(): string {
    // Se il task è completato o in errore, colora ogni colonna rispettivamente di verdo o rosso
    if (this.isTaskCompleted) return 'completed';
    if (this.isTaskFailed) return 'error';

    // Se l'iter è selezionato, la colonna è verde.
    if (this.iterSelected) return 'completed';

    return '';
  }

  // Pratiche (seconda e terza colonna)

  get praticesColumnClass(): string {
    // Se il task è completato o in errore, colora ogni colonna rispettivamente di verdo o rosso
    if (this.isTaskCompleted) return 'completed';
    if (this.isTaskFailed) return 'error';

    // Se è un figlia termica e sia il progetto e il computo metrico sono completati,
    // la colonna è verde.
    if (this.childProjectType === 'termica-figlia' && this.hasP && this.hasC) return 'completed';

    return '';
  }

  // Verifiche (quarta colonna)

  get verificationsNotes(): string | null {
    return this.childProjectType === 'termica-figlia'
      ? this.operationChild?.tVerificationsNotes ?? null
      : this.operationChild?.eVerificationsNotes ?? null;
  }

  get verificationsColumnClass(): string {
    // Se il task è completato o in errore, colora ogni colonna rispettivamente di verdo o rosso
    if (this.isTaskCompleted) return 'completed';
    if (this.isTaskFailed) return 'error';

    return '';
  }

  onEdit() {
    console.log('OperationPraticesAndVerifications: onEdit()'); // eslint-disable-line no-console
    this.$emit('edit');
  }
}
